import React, { Component } from "react";
import axios from "axios";
import Report from "./Report";
const config = require("../config.json");

export default class ReportAdmin extends Component {
  state = {
    reports: [],
  };

  handleDeleteReport = async (id, event) => {
    event.preventDefault();
    if (
      window.confirm("Dette vil slette anmeldelsen for evigt. Er du sikker?")
    ) {
      try {
        await axios.delete(`${config.api.invokeUrl}/reports/${id}`);
      } catch (err) {
        console.log(err);
      }
      const updatedReports = [...this.state.reports].filter(
        (report) => report.id !== id
      );
      this.setState({ reports: updatedReports });
    }
  };

  fetchReports = async () => {
    try {
      const res = await axios.get(`${config.api.invokeUrl}/reports`);
      const reports = res.data;
      this.setState({ reports: reports });
    } catch (err) {
      console.log(err);
    }
  };

  componentDidMount = () => {
    this.fetchReports();
  };

  render() {
    return (
      <>
        <section className="section">
          <div className="container">
            <h1>Anmeldelser Admin</h1>
            <p className="subtitle is-5">Se anmeldelser</p>
            <br />
            <div className="columns is-multiline">
              <div className="column">
                <div className="tile is-ancestor ">
                  <div className="tile is-parent flex-column">
                    {this.state.reports.map((report) => (
                      <Report
                        handleDeleteReport={this.handleDeleteReport}
                        report={report}
                        key={report.id}
                        isAdmin={true}
                      />
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </>
    );
  }
}
